var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 370 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5155_116579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 56V0H41.3637C47.3166 0 51.6583 1.19058 54.3888 3.56461C57.1122 5.93864 58.4738 8.81171 58.4738 12.1696V15.0213C58.4738 17.6234 57.9178 19.7622 56.8127 21.4376C55.7006 23.1201 54.5171 24.3035 53.2481 25.0022C56.0357 25.8933 58.2528 27.4261 59.9068 29.6148C61.5537 31.8034 62.3807 34.6694 62.3807 38.2197V39.9307C62.3807 41.8342 62.1596 43.7306 61.7176 45.6341C61.2756 47.5376 60.4344 49.2629 59.201 50.8171C57.9677 52.3712 56.221 53.6188 53.9682 54.5742C51.7153 55.5223 48.7852 56 45.1707 56H0ZM12.5474 22.4428H39.3675C41.5847 22.5069 43.2316 21.9509 44.3152 20.7817C45.3917 19.6125 45.9335 18.1367 45.9335 16.3616V15.4134C45.9335 13.959 45.4274 12.5474 44.415 11.1786C43.4027 9.81693 41.4992 9.13253 38.7117 9.13253H12.5474V22.4428ZM12.5474 46.8817H42.5044C44.9141 46.8817 46.7392 46.2829 47.9725 45.078C49.2059 43.8732 49.8261 42.2263 49.8261 40.1375V38.4265C49.8261 36.4588 49.0989 34.8619 47.6374 33.6214C46.1759 32.388 43.7734 31.7678 40.4084 31.7678H12.5474V46.8889V46.8817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.657 0.0927734L191.141 51.2948L170.581 28.0464L191.591 5.70347L195.298 0.0927734H180.084L161.641 21.1026H160.593L142.242 0.0927734H127.028L151.752 28.0464L130.643 50.2967L127.028 56.0001H142.242L160.593 34.7978H161.641L180.084 56.0001H202.676L208.857 43.9232H242.899L248.51 56.0001H263.154L235.385 0.0927734H216.657ZM212.287 34.6053L225.404 8.64783H226.353L239.378 34.6053H212.28H212.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.13 0.0926798L340.057 17.8729L335.686 23.7688H334.731L330.361 17.8729L316.288 0.0926798H312.816V0H250.635V9.1254H275.359L275.452 56H287.999V9.1254H308.716L328.742 32.8015V56H341.297V33.1865L365.636 5.80318L369.343 0.0926798H354.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6163 0.349609H77.5518V11.4142H88.6163V0.349609Z",
    fill: "url(#paint0_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6808 0.349609H88.6162V11.4142H99.6808V0.349609Z",
    fill: "url(#paint1_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.745 0.349609H99.6807V11.4142H110.745V0.349609Z",
    fill: "url(#paint2_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5587 33.5361H66.4941V44.6007H77.5587V33.5361Z",
    fill: "url(#paint3_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5587 22.4717H66.4941V33.5362H77.5587V22.4717Z",
    fill: "url(#paint4_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5587 11.4072H66.4941V22.4718H77.5587V11.4072Z",
    fill: "url(#paint5_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.803 33.5361H110.738V44.6007H121.803V33.5361Z",
    fill: "url(#paint6_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.803 22.4717H110.738V33.5362H121.803V22.4717Z",
    fill: "url(#paint7_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.803 11.4072H110.738V22.4718H121.803V11.4072Z",
    fill: "url(#paint8_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6163 44.5928H77.5518V55.6573H88.6163V44.5928Z",
    fill: "url(#paint9_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6808 44.5928H88.6162V55.6573H99.6808V44.5928Z",
    fill: "url(#paint10_linear_5155_116579)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.745 44.5928H99.6807V55.6573H110.745V44.5928Z",
    fill: "url(#paint11_linear_5155_116579)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5155_116579",
    x1: 53.4764,
    y1: 37.5356,
    x2: 99.025,
    y2: -11.1712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5155_116579",
    x1: 59.3793,
    y1: 43.0536,
    x2: 104.928,
    y2: -5.64607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5155_116579",
    x1: 65.2822,
    y1: 48.5716,
    x2: 110.831,
    y2: -0.128017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5155_116579",
    x1: 64.1344,
    y1: 47.5023,
    x2: 109.683,
    y2: -1.20455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5155_116579",
    x1: 58.6164,
    y1: 42.3408,
    x2: 104.165,
    y2: -6.36601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5155_116579",
    x1: 53.0983,
    y1: 37.1793,
    x2: 98.6469,
    y2: -11.5275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5155_116579",
    x1: 87.7394,
    y1: 69.5743,
    x2: 133.288,
    y2: 20.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5155_116579",
    x1: 82.2214,
    y1: 64.4129,
    x2: 127.763,
    y2: 15.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5155_116579",
    x1: 76.6963,
    y1: 59.2514,
    x2: 122.245,
    y2: 10.5517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5155_116579",
    x1: 75.5556,
    y1: 58.1811,
    x2: 121.104,
    y2: 9.47424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5155_116579",
    x1: 81.4513,
    y1: 63.6991,
    x2: 127,
    y2: 14.9923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5155_116579",
    x1: 87.3543,
    y1: 69.2171,
    x2: 132.903,
    y2: 20.5103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5155_116579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369.343,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo_full.bd0a4de61af64c803b27867b7c91e50f.svg";
export { ForwardRef as ReactComponent };